import { StatusIndicator } from '@strata/react-status-indicators';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { isRouteExpired } from 'services/RouteRuleHelpers';

const Statuses = { ACTIVE: 'ACTIVE', INACTIVE: 'INACTIVE', PEND_START: 'PEND. START' };

const getStatus = ({ isActive, startDate, endDate }) => {
    if (isActive === false || isRouteExpired(endDate)) {
        return { status: StatusIndicator.Status.DEFAULT, message: Statuses.INACTIVE };
    }

    if (startDate && dayjs().isBefore(startDate)) {
        return { status: StatusIndicator.Status.IN_PROGRESS, message: Statuses.PEND_START };
    }

    return { status: StatusIndicator.Status.SUCCESS, message: Statuses.ACTIVE };
};

export const RouteStatusIndicator = ({
    isActive = undefined,
    startDate = undefined,
    endDate = undefined,
}) => {
    const { status, message } = getStatus({ isActive, startDate, endDate });
    return <StatusIndicator status={status} message={message} />;
};

RouteStatusIndicator.Statuses = Statuses;
RouteStatusIndicator.getStatus = getStatus;

RouteStatusIndicator.propTypes = {
    isActive: PropTypes.bool,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
};
